import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ApiServiceListService } from 'src/app/_services/api/api-service-list.service';
import { CommonService } from 'src/app/_services/common/common.service';
import { LoginRoles } from 'src/app/model/common.model';
import { LocalizedString } from 'src/app/model/localized-string.model';
import { AuthServiceUser } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-monthly-create',
    templateUrl: './monthly-create.component.html',
    styleUrl: './monthly-create.component.css',
    standalone: false
})
export class MonthlyCreateComponent {
  showLoader: boolean = false;
  public breadcrumb: any;
  options = {
    close: false,
    expand: false,
    minimize: false,
    reload: false
  };
  closeResult = '';
  dropdownSettings: any = {};
  dropdownSettingsMulti: any = {};
  dropdownSettingsZone = {
    singleSelection: true,
    idField: '_id',
    textField: 'name',
    enableCheckAll: false,
    itemsShowLimit: 10,
    allowSearchFilter: true,
    closeDropDownOnSelection: true
  };
  dropdownSettingsRetailer = {
    singleSelection: true,
    idField: '_id',
    textField: 'name',
    enableCheckAll: false,
    itemsShowLimit: 10,
    allowSearchFilter: true,
    closeDropDownOnSelection: true
  };
  dropdownSettingsCategory = {
    singleSelection: true,
    idField: '_id',
    textField: 'displayName',
    enableCheckAll: false,
    itemsShowLimit: 10,
    allowSearchFilter: true,
    closeDropDownOnSelection: true
  };

  model: any = {
    name: { en: '', te: '' },
    description: { en: '', te: '' },
    category: [],
    relevantService: '',
    relevantPrasadam: '',
    discorselling: 'disc',
    status: true,
  };
  rows: any;
  isEditPage: boolean = false;
  selectProduct: any = {};
  mainCategoryList: any = [];
  categoryList: any = [];
  subCategoryList: any = [];
  productList: any = [];
  monthlyPack: any = {
    list: [],
    total: 0
  }
  freePack: any = {
    list: [],
    total: 0
  }
  monthlyTempArr = new Set<string>();
  freeTempArr = new Set<string>();
  showDiscount: boolean = true;
  showSelling: boolean = false;
  noListErrorMsg: string = '';
  private routeSub: Subscription;
  zoneList = [];
  packageCategoryList: any[] = [];
  retailerList: any[] = [];
  serviceCategoryList: any[] = [];
  selectedRelevantServiceCategory = [];
  kitchenMainCategoryId: string = '';
  prasadamCategoryList: any[] = [];
  prasadamSubCategoryList: any[] = [];
  selectedPrasadamCategory = [];
  selectedPrasadamSubCategory = [];
  selectedRelevantPrasadamRetailer = [];
  relevantServiceOptions: any[] = [];
  relevantPrasadamOptions: any[] = [];
  relevantPrasadamRetailerList: any[] = [];
  pendingRelevantServiceCategoryId: string = '';
  pendingPrasadamCategoryId: string = '';
  pendingPrasadamSubCategoryId: string = '';
  pendingRelevantPrasadamRetailerId: string = '';
  pendingRelevantServiceLabel: string = '';
  pendingRelevantPrasadamLabel: string = '';
  isZoneAdmin: boolean = false;
  loginUserDetails: any;

  constructor(private route: ActivatedRoute, private authServiceUser: AuthServiceUser, private http: HttpClient, private apiService: ApiServiceListService, private router: Router, private modalService: NgbModal, private toastr: ToastrService, protected cmnService: CommonService) {
    this.routeSub = this.route.params.subscribe(params => {
      // console.log(params) //log the entire params object
      // console.log(params['id']) //log the value of id
      if (params != undefined && params['id'] != undefined) {
        this.isEditPage = true
        this.getItemById(params['id']);
      } else {
        this.isEditPage = false;
      }
      this.breadcrumb = {
        'mainlabel': 'Package',
        'links': [
          {
            'name': this.isEditPage ? 'Edit Package' : 'Add Package',
            'isLink': false,
            'link': '#'
          },
        ]
      };
    });

  }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: '_id',
      textField: 'name',

      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };

    this.dropdownSettingsMulti = {
      singleSelection: false,
      idField: '_id',
      dataField: this.productList,
      textField: 'fullProduct',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.loginUserDetails = this.authServiceUser.getUserInfo();
    this.isZoneAdmin = this.loginUserDetails.role.includes(LoginRoles.ZONEADMIN);
    this.getServiceCategories();
    this.getKitchenMainCategory();
    this.getPackageCategories();
    if (this.isZoneAdmin) {
      this.model.zone = [{ _id: this.loginUserDetails.zone._id }];
      this.getRetailersByZone(this.loginUserDetails.zone._id);
      this.loadRelevantServiceOptions();
      this.loadRelevantPrasadamRetailers(this.loginUserDetails.zone._id);
    } else {
      this.getZonesList();
    }

  }

  onZoneselect(event, modal) {
    if (this.monthlyPack.list.length > 0 || this.freePack.list.length > 0) {
      this.modalService.open(modal, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', size: 'sm', centered: true }).result.then((result) => {
        console.log("self.selectObj", result);
        if (result == 'Ok click') {
          this.monthlyPack = {
            list: [],
            total: 0
          }
          this.freePack = {
            list: [],
            total: 0
          }
          this.syncRetailersForSelectedZone();
          this.loadRelevantServiceOptions();
          this.loadRelevantPrasadamRetailers(this.model.zone?.[0]?._id);
        } else {
          this.model.zone = [event];
          this.syncRetailersForSelectedZone();
          this.loadRelevantServiceOptions();
          this.loadRelevantPrasadamRetailers(this.model.zone?.[0]?._id);
        }


      }, (reason) => {
        console.log("close");

        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    } else {
      this.syncRetailersForSelectedZone();
      this.loadRelevantServiceOptions();
      this.loadRelevantPrasadamRetailers(this.model.zone?.[0]?._id);
    }
  }

  getZonesList() {
    this.apiService.getZonesList().subscribe(
      {
        next: (response: any) => {
          this.zoneList = response.data;
          this.loadRelevantServiceOptions();
          this.loadRelevantPrasadamRetailers(this.model.zone?.[0]?._id);
        },
        error: (err) => {
          console.log(err);
        }
      }
    );
  }

  getItemById(id) {
    let parameter: any = {
      methodType: "GET",
    }
    this.apiService.getMonthlyPackByIdAPI(parameter, id).subscribe(
      {
        next: (response: any) => {
          if (response.success) {
            console.log(response.data);

            this.model = { ...response.data };
            this.model.name = this.toLocalizedStringWithFallback(this.model.name, [
              this.model.nameTe,
              this.model.name_te,
              this.model.teName,
              this.model.teluguName,
            ]);
            this.model.description = this.toLocalizedStringWithFallback(this.model.description, [
              this.model.descriptionTe,
              this.model.description_te,
              this.model.teDescription,
              this.model.teluguDescription,
            ]);
            this.model.category = this.model.category ? [this.withDisplayName(this.model.category)] : [];
            this.model.relevantService = this.resolveOptionalId(response.data?.relevantService) || '';
            this.model.relevantPrasadam = this.resolveOptionalId(response.data?.relevantPrasadam) || '';

            this.model.zone = [];
            if (response.data.zone) {
              const element = response.data.zone;
              this.model.zone.push({ _id: element._id, name: element.name });
              this.getRetailersByZone(element._id);
              this.loadRelevantServiceOptions();
              this.loadRelevantPrasadamRetailers(element._id);
            }

            this.model.status = this.cmnService.getStatusRetrunValue(response.data.status);
            this.monthlyPack.list = response.data.products;
            this.monthlyPack.total = response.data.grossAmount;
            this.model.sellingPrice = response.data.netAmount;
            if (response.data.freePack?.length > 0) {
              this.freePack.list = response.data.freePack;
              this.freePack.total = this.freePack.list.reduce((sum, element) => sum + (element.mrpPrice * element.quantity || 0), 0);
            }
            this.model.discorselling = 'disc';
            this.pendingRelevantPrasadamRetailerId =
              this.resolveOptionalId(response.data?.relevantPrasadam?.retailer) || '';
            this.pendingRelevantServiceLabel = this.getLocalizedText(response.data?.relevantService?.name);
            this.pendingRelevantPrasadamLabel = this.getLocalizedText(response.data?.relevantPrasadam?.product?.name);
            this.hydrateRelevantServiceSelection(response.data?.relevantService);
            this.hydrateRelevantPrasadamSelection(response.data?.relevantPrasadam);
            this.ensureSelectedRelevantServiceOption();
            this.ensureSelectedRelevantPrasadamOption();
          }

        },
        error: (err) => {
          console.log(err);

        }
      }
    );
    // tempModel.page = this.changeToMulti(tempModel.page);

  }
  openModal(OpenShowModelContent) {
    let self = this;
    this.getMainCategory();
    self.modalService.open(OpenShowModelContent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', size: 'xl', centered: true }).result.then((result) => {
      console.log("self.selectObj", result);
      if (result == 'Save Click') {
      } else {
        this.closeResult = `Dismissed ${this.getDismissReason(result)}`;
      }


    }, (reason) => {
      console.log("close");

      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    // console.log(reason);

    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  increaseQuantity(index: number, type): void {
    if (type === 'monthly') {
      this.monthlyPack.list[index].quantity++;
      this.calculateMonthlyPassPrice();
    } else {
      this.freePack.list[index].quantity++;
      this.calculateFreePassPrice();
    }
  }

  calculateMonthlyPassPrice() {
    this.monthlyPack.total = this.monthlyPack.list.reduce(
      (total, element) => total + element.mrpPrice * element.quantity,
      0
    );
  }
  calculateFreePassPrice() {
    this.freePack.total = this.freePack.list.reduce(
      (total, element) => total + element.mrpPrice * element.quantity,
      0
    );

  }

  decreaseQuantity(index: number, type): void {
    if (type === 'monthly') {
      this.monthlyPack.list[index].quantity--;
      this.calculateMonthlyPassPrice();
    } else {
      this.freePack.list[index].quantity--;
      this.calculateFreePassPrice();
    }

  }

  addToPack(pack: string) {
    // console.log(this.selectProduct.selectedProduct);

    if (pack == 'monthly') {
      console.log(this.selectProduct.selectedProduct);
      this.monthlyTempArr = new Set();
      for (let i = 0; i < this.productList.length; i++) {
        const element = this.productList[i];
        for (let j = 0; j < this.selectProduct.selectedProduct.length; j++) {
          const element2 = this.selectProduct.selectedProduct[j];
          if (element2._id == element._id) {
            this.monthlyTempArr.add({ ...element, quantity: 1 });
          }
        }
      }
      // this.finalList = new Set(tempArr);
      // this.monthlyPack.list = Array.from(new Set([...this.monthlyPack.list, ...(Array.from(this.monthlyTempArr))]));
      this.monthlyPack.list = Array.from(
        [...this.monthlyPack.list, ...(Array.from(this.monthlyTempArr))].reduce((map, item) => {
          if (!map.has(item._id)) {
            map.set(item._id, item);
          }
          return map;
        }, new Map()).values()
      );
      this.calculateMonthlyPassPrice();
    } else {
      this.freeTempArr = new Set();
      for (let i = 0; i < this.productList.length; i++) {
        const element = this.productList[i];
        for (let j = 0; j < this.selectProduct.selectedProduct.length; j++) {
          const element2 = this.selectProduct.selectedProduct[j];
          if (element2._id == element._id) {
            this.freeTempArr.add({ ...element, quantity: 1 });
          }
        }
      }
      // this.finalList = new Set(tempArr);
      // this.freePack.list = Array.from(new Set([...this.freePack.list, ...(Array.from(this.freeTempArr))]));

      this.freePack.list = Array.from(
        [...this.freePack.list, ...(Array.from(this.freeTempArr))].reduce((map, item) => {
          if (!map.has(item._id)) {
            map.set(item._id, item);
          }
          return map;
        }, new Map()).values()
      );

      this.calculateFreePassPrice();
    }
  }

  removeProduct(i, item) {
    if (item == 'monthly') {
      this.monthlyPack.list.splice(i, 1);
      this.calculateMonthlyPassPrice();
    } else {
      this.freePack.list.splice(i, 1);
      this.calculateFreePassPrice();
    }
  }

  discountOrSelling() {
    if (this.model.discorselling == 'disc') {
      delete this.model.sellingPrice;
      this.showDiscount = true;
      this.showSelling = false;
      this.getMainCategory();
    } else {
      delete this.model.discount;
      this.showDiscount = false;
      this.showSelling = true;
    }
  }

  getPackageCategories() {
    this.apiService.getPackageCategories().subscribe({
      next: (response: any) => {
        const categories = Array.isArray(response?.data) ? response.data : [];
        this.packageCategoryList = categories.map((item) => this.withDisplayName(item));
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getMainCategory() {
    let parameter: any = {
      methodType: "GET",
    }
    this.apiService.getMainCategoryList(parameter).subscribe({
      next: (response: any) => {
        if (response.success)
          this.mainCategoryList = this.normalizeCategoryOptions(response.data)
            .filter(item => item.name !== 'Rakee Kitchen');
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {
        console.log("Comple");

      }
    });
  }
  updateDrpdown(type: string) {
    if (type == 'main') {
      this.getCategory();
      this.selectProduct.category = undefined;
      this.selectProduct.subCategory = undefined;
      this.selectProduct.selectedProduct = undefined;


    } else if (type == 'cate') {
      this.getSubCategory();
      this.selectProduct.subCategory = undefined;
      this.selectProduct.selectedProduct = undefined;
    } else if (type == 'sub') {
      this.getProductList();
      this.selectProduct.selectedProduct = undefined;
    } else if (type == 'retailer') {
      this.selectProduct.selectedProduct = undefined;
      if (this.selectProduct.subCategory?.[0]?._id) {
        this.getProductList();
      }
    }
  }


  getCategory() {
    let parameter: any = {
      methodType: "POST",
    }
    let body: any = {};
    console.log(this.selectProduct.mainc);

    body.mainCategory = this.selectProduct.mainCategory[0]?._id;
    this.apiService.getCategoryList(parameter, body).subscribe({
      next: (response: any) => {
        this.categoryList = this.normalizeCategoryOptions(response.data);
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {

      }
    });
  }

  getSubCategory() {
    let parameter: any = {
      methodType: "POST",
    }
    let body: any = {};
    body.category = this.selectProduct.category[0]?._id;
    this.apiService.getSubCategoryList(parameter, body).subscribe({
      next: (response: any) => {
        this.subCategoryList = this.normalizeCategoryOptions(response.data);
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {

      }
    });
  }

  getProductList() {
    if (!this.model.zone || this.model.zone.length === 0) {
      this.toastr.error('Please select zone first', '', { timeOut: 3000, });
      return;
    }

    let body = {
      subCategory: this.selectProduct.subCategory[0]._id,
      zone: this.model.zone[0]._id,
    }

    this.apiService.getProductBySubCategory(body).subscribe(
      {
        next: (response: any) => {
          const selectedRetailerId = this.selectProduct.retailer?.[0]?._id;
          const retailerNameMap = new Map(this.retailerList.map((item) => [item._id, item.name]));
          const rawData = Array.isArray(response?.data) ? response.data : [];
          const filteredData = selectedRetailerId
            ? rawData.filter((item) => item.retailer === selectedRetailerId)
            : rawData;
          let tempProducts = [];
          for (let i = 0; i < filteredData.length; i++) {
            const element = filteredData[i];
            const retailerName = retailerNameMap.get(element.retailer) || 'No retailer';
            const rentalLabel =
              element.type === 'rental' && element.rentalPeriodValue && element.rentalPeriodUnit
                ? `${element.rentalPeriodValue} ${element.rentalPeriodUnit}`
                : '';
            const unitLabel = [element.unitValue, element.unit].filter(Boolean).join(' ').trim();
            const descriptor = rentalLabel || unitLabel;
            element.fullProduct = descriptor
              ? `${element.name} (${descriptor}) - ${retailerName}`
              : `${element.name} - ${retailerName}`;
            tempProducts.push(element)
          }
          this.productList = tempProducts;
          console.log(this.productList);


        },
        error: (err) => {
          console.log(err);

        }
      }
    );
  }

  getRetailersByZone(zoneId: string) {
    if (!zoneId) {
      this.retailerList = [];
      return;
    }
    this.apiService.getRetailerByZoneData({
      zone: zoneId,
      type: ['grocery', 'kitchen']
    }).subscribe({
      next: (response: any) => {
        const data = Array.isArray(response?.data) ? response.data : [];
        this.retailerList = data.map((item) => ({
          _id: item._id,
          name: item.type ? `${item.name} (${item.type})` : item.name,
        }));
      },
      error: () => {
        this.retailerList = [];
      }
    });
  }

  private syncRetailersForSelectedZone() {
    const zoneId = this.model.zone?.[0]?._id;
    this.selectProduct.retailer = [];
    this.productList = [];
    if (!zoneId) {
      this.retailerList = [];
      return;
    }
    this.getRetailersByZone(zoneId);
  }

  private getFirstNonEmptyString(values: any[] = []): string {
    const validValue = values.find((item) => typeof item === 'string' && item.trim() !== '');
    return typeof validValue === 'string' ? validValue : '';
  }

  private toLocalizedString(value: any): LocalizedString {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      return { en: value.en ?? '', te: value.te ?? '' };
    }
    if (typeof value === 'string') {
      return { en: value, te: '' };
    }
    return { en: '', te: '' };
  }

  private toLocalizedStringWithFallback(value: any, teFallbacks: any[] = [], enFallbacks: any[] = []): LocalizedString {
    let en = '';
    let te = '';

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      en = this.getFirstNonEmptyString([
        value.en,
        value.english,
        value.enUS,
        value.en_us,
        value['en-US'],
        value['en-IN'],
      ]);

      te = this.getFirstNonEmptyString([
        value.te,
        value.telugu,
        value.teIN,
        value.te_in,
        value['te-IN'],
      ]);
    } else if (typeof value === 'string') {
      en = value;
    }

    if (!en) en = this.getFirstNonEmptyString(enFallbacks);
    if (!te) te = this.getFirstNonEmptyString(teFallbacks);

    return { en, te };
  }

  private withDisplayName(item: any): any {
    if (!item || typeof item !== 'object') return item;
    return {
      ...item,
      displayName: this.getLocalizedText(item.name),
    };
  }

  private normalizeCategoryOptions(list: any[] = []): any[] {
    return list.map((item) => ({
      ...item,
      name: this.getLocalizedText(item?.name),
    }));
  }

  private getLocalizedText(value: any): string {
    const localized = this.toLocalizedString(value);
    return localized.en || localized.te || '';
  }

  private resolveOptionalId(value: any): string {
    if (!value) return '';
    if (typeof value === 'object') {
      return value._id || value.id || '';
    }
    return String(value);
  }

  onRelevantServiceCategoryChange() {
    this.loadRelevantServiceOptions();
  }

  onPrasadamCategoryChange() {
    const categoryId = this.resolveCategoryId(this.selectedPrasadamCategory);
    this.selectedPrasadamSubCategory = [];
    this.prasadamSubCategoryList = [];
    this.relevantPrasadamOptions = [];
    if (!categoryId) {
      this.ensureSelectedRelevantPrasadamOption();
      return;
    }

    const parameter = { methodType: 'POST' };
    this.apiService.getSubCategoryList(parameter, { category: categoryId }).subscribe({
      next: (response: any) => {
        this.prasadamSubCategoryList = (response.data || []).map((item) => this.withDisplayName(item));
        if (this.pendingPrasadamSubCategoryId) {
          const matchedSubCategory = this.prasadamSubCategoryList.find(
            (item) => item?._id === this.pendingPrasadamSubCategoryId
          );
          if (matchedSubCategory) {
            this.selectedPrasadamSubCategory = [matchedSubCategory];
          }
          this.pendingPrasadamSubCategoryId = '';
        }
        this.loadRelevantPrasadamOptions(this.model.zone?.[0]?._id);
      },
      error: () => {
        this.prasadamSubCategoryList = [];
      }
    });
  }

  onPrasadamSubCategoryChange() {
    this.loadRelevantPrasadamOptions(this.model.zone?.[0]?._id);
  }

  onRelevantPrasadamRetailerChange() {
    this.loadRelevantPrasadamOptions(this.model.zone?.[0]?._id);
  }

  private resolveCategoryId(categorySelection: any): string {
    const first = Array.isArray(categorySelection) ? categorySelection[0] : categorySelection;
    return first?._id || first?.categoryId || first || '';
  }

  getServiceCategories() {
    this.apiService.getServiceCategories().subscribe({
      next: (response: any) => {
        this.serviceCategoryList = (response.data || []).map((item) => this.withDisplayName(item));
        if (this.pendingRelevantServiceCategoryId) {
          const matchedCategory = this.serviceCategoryList.find(
            (item) => item?._id === this.pendingRelevantServiceCategoryId
          );
          if (matchedCategory) {
            this.selectedRelevantServiceCategory = [matchedCategory];
            this.loadRelevantServiceOptions();
          }
          this.pendingRelevantServiceCategoryId = '';
        }
      },
      error: () => {
        this.serviceCategoryList = [];
      }
    });
  }

  loadRelevantServiceOptions() {
    const categoryId = this.resolveCategoryId(this.selectedRelevantServiceCategory);
    if (!categoryId) {
      this.relevantServiceOptions = [];
      this.ensureSelectedRelevantServiceOption();
      return;
    }

    const scopedZoneId = this.model.zone?.[0]?._id;
    if (!scopedZoneId) {
      this.relevantServiceOptions = [];
      this.ensureSelectedRelevantServiceOption();
      return;
    }

    const parameter: any = {
      body: {
        pageSize: 500,
        currentPage: 1,
        totalCount: 0,
        filteredValue: [{ status: ['Active'] }, { category: [categoryId] }, { zones: [scopedZoneId] }],
        searchValue: '',
        sortColumn: 'updatedAt',
        sortOrder: 'desc',
      }
    };

    this.apiService.getServiceTableData(parameter).subscribe({
      next: (response: any) => {
        const rows = Array.isArray(response?.data?.tableData) ? response.data.tableData : [];
        this.relevantServiceOptions = rows.map((row) => ({
          _id: row._id,
          name: row.name || row._id,
        }));
        this.ensureSelectedRelevantServiceOption();
      },
      error: () => {
        this.relevantServiceOptions = [];
        this.ensureSelectedRelevantServiceOption();
      }
    });
  }

  loadRelevantPrasadamRetailers(zoneId?: string) {
    const scopedZoneId = zoneId || this.model.zone?.[0]?._id;
    if (!scopedZoneId) {
      this.relevantPrasadamRetailerList = [];
      this.selectedRelevantPrasadamRetailer = [];
      this.loadRelevantPrasadamOptions();
      return;
    }

    this.apiService.getRetailersListByZoneAndType({ zone: scopedZoneId, type: 'kitchen' }).subscribe({
      next: (response: any) => {
        const rows = Array.isArray(response?.data) ? response.data : [];
        this.relevantPrasadamRetailerList = rows.map((row) => ({
          _id: row._id,
          name: row.name || row._id,
        }));

        const preferredRetailerId =
          this.resolveOptionalId(this.selectedRelevantPrasadamRetailer?.[0]) ||
          this.pendingRelevantPrasadamRetailerId;
        if (preferredRetailerId) {
          const matchedRetailer = this.relevantPrasadamRetailerList.find(
            (item) => item?._id === preferredRetailerId
          );
          this.selectedRelevantPrasadamRetailer = matchedRetailer ? [matchedRetailer] : [];
        }
        this.pendingRelevantPrasadamRetailerId = '';
        this.loadRelevantPrasadamOptions(scopedZoneId);
      },
      error: () => {
        this.relevantPrasadamRetailerList = [];
        this.selectedRelevantPrasadamRetailer = [];
        this.loadRelevantPrasadamOptions(scopedZoneId);
      }
    });
  }

  loadRelevantPrasadamOptions(zoneId?: string) {
    const subCategoryId = this.resolveCategoryId(this.selectedPrasadamSubCategory);
    if (!subCategoryId) {
      this.relevantPrasadamOptions = [];
      this.ensureSelectedRelevantPrasadamOption();
      return;
    }

    const scopedZoneId = zoneId || this.model.zone?.[0]?._id;
    if (!scopedZoneId) {
      this.relevantPrasadamOptions = [];
      this.ensureSelectedRelevantPrasadamOption();
      return;
    }

    const retailerId = this.resolveOptionalId(this.selectedRelevantPrasadamRetailer?.[0]);
    if (!retailerId) {
      this.relevantPrasadamOptions = [];
      this.ensureSelectedRelevantPrasadamOption();
      return;
    }

    const filteredValue: any[] = [
      { type: ['kitchen'] },
      { zone: [scopedZoneId] },
      { subCategory: [subCategoryId] },
      { retailer: [retailerId] },
    ];

    const parameter: any = {
      body: {
        pageSize: 1000,
        currentPage: 1,
        totalCount: 0,
        filteredValue,
        searchValue: '',
        sortColumn: 'updatedAt',
        sortOrder: 'desc',
      }
    };

    this.apiService.getProductList(parameter).subscribe({
      next: (response: any) => {
        const rows = Array.isArray(response?.data?.tableData) ? response.data.tableData : [];
        this.relevantPrasadamOptions = rows.map((row) => ({
          _id: row._id,
          name: [row.name, row.retailer].filter(Boolean).join(' - ') || row._id,
        }));
        this.ensureSelectedRelevantPrasadamOption();
      },
      error: () => {
        this.relevantPrasadamOptions = [];
        this.ensureSelectedRelevantPrasadamOption();
      }
    });
  }

  getKitchenMainCategory() {
    const parameter: any = { methodType: 'GET' };
    this.apiService.getKitchenMainCategory(parameter).subscribe({
      next: (response: any) => {
        this.kitchenMainCategoryId = response?.data?._id || '';
        this.loadPrasadamCategories();
      },
      error: () => {
        this.kitchenMainCategoryId = '';
        this.prasadamCategoryList = [];
      }
    });
  }

  loadPrasadamCategories() {
    if (!this.kitchenMainCategoryId) {
      this.prasadamCategoryList = [];
      return;
    }

    const parameter: any = { methodType: 'POST' };
    this.apiService.getCategoryList(parameter, { mainCategory: this.kitchenMainCategoryId }).subscribe({
      next: (response: any) => {
        this.prasadamCategoryList = (response.data || []).map((item) => this.withDisplayName(item));
        if (this.pendingPrasadamCategoryId) {
          const matchedCategory = this.prasadamCategoryList.find(
            (item) => item?._id === this.pendingPrasadamCategoryId
          );
          if (matchedCategory) {
            this.selectedPrasadamCategory = [matchedCategory];
            this.onPrasadamCategoryChange();
          }
          this.pendingPrasadamCategoryId = '';
        }
      },
      error: () => {
        this.prasadamCategoryList = [];
      }
    });
  }

  private ensureSelectedRelevantServiceOption() {
    const selectedValue = this.model.relevantService;
    const selectedId = this.resolveOptionalId(selectedValue);
    if (!selectedId) return;
    if (this.relevantServiceOptions.some((item) => item._id === selectedId)) return;

    const label =
      (typeof selectedValue === 'object' && this.getLocalizedText(selectedValue?.name)) ||
      (typeof selectedValue === 'object' && selectedValue?.name) ||
      this.pendingRelevantServiceLabel ||
      selectedId;

    const item = { _id: selectedId, name: label };
    this.relevantServiceOptions = [item, ...this.relevantServiceOptions.filter((opt) => opt._id !== item._id)];
    this.pendingRelevantServiceLabel = '';
  }

  private ensureSelectedRelevantPrasadamOption() {
    const selectedValue = this.model.relevantPrasadam;
    const selectedId = this.resolveOptionalId(selectedValue);
    if (!selectedId) return;
    if (this.relevantPrasadamOptions.some((item) => item._id === selectedId)) return;

    const label =
      (typeof selectedValue === 'object' &&
        selectedValue?.product &&
        this.getLocalizedText(selectedValue.product.name)) ||
      (typeof selectedValue === 'object' && selectedValue?.name) ||
      this.pendingRelevantPrasadamLabel ||
      selectedId;

    const item = { _id: selectedId, name: label };
    this.relevantPrasadamOptions = [item, ...this.relevantPrasadamOptions.filter((opt) => opt._id !== item._id)];
    this.pendingRelevantPrasadamLabel = '';
  }

  private hydrateRelevantServiceSelection(relevantService: any) {
    const serviceId = this.resolveOptionalId(relevantService);
    if (!serviceId) return;

    this.apiService.getServiceById(serviceId).subscribe({
      next: (response: any) => {
        const service = response?.data || {};
        const serviceName = this.getLocalizedText(service?.name) || this.getLocalizedText(relevantService?.name) || serviceId;
        this.relevantServiceOptions = [
          { _id: serviceId, name: serviceName },
          ...this.relevantServiceOptions.filter((opt) => opt._id !== serviceId),
        ];
        const categoryId = this.resolveOptionalId(service?.category);
        if (categoryId && !this.resolveCategoryId(this.selectedRelevantServiceCategory)) {
          const matchedCategory = this.serviceCategoryList.find((item) => item?._id === categoryId);
          if (matchedCategory) {
            this.selectedRelevantServiceCategory = [matchedCategory];
            this.loadRelevantServiceOptions();
          } else {
            this.pendingRelevantServiceCategoryId = categoryId;
          }
        }
      },
      error: () => {},
    });
  }

  private hydrateRelevantPrasadamSelection(relevantPrasadam: any) {
    const productId = this.resolveOptionalId(relevantPrasadam?.product);
    const relevantPrasadamId = this.resolveOptionalId(relevantPrasadam?._id || relevantPrasadam);
    if (!productId || !relevantPrasadamId) return;

    this.apiService.getProductById({ methodType: 'GET' }, productId).subscribe({
      next: (response: any) => {
        const product = response?.data?.product || {};
        const productZones = Array.isArray(response?.data?.productZones) ? response.data.productZones : [];
        const zoneRow = productZones.find((item: any) => this.resolveOptionalId(item?._id) === relevantPrasadamId);

        const prasadamName =
          this.getLocalizedText(relevantPrasadam?.product?.name) ||
          this.getLocalizedText(product?.name) ||
          relevantPrasadamId;
        this.relevantPrasadamOptions = [
          { _id: relevantPrasadamId, name: prasadamName },
          ...this.relevantPrasadamOptions.filter((opt) => opt._id !== relevantPrasadamId),
        ];

        const categoryId = this.resolveOptionalId(product?.category?.[0]);
        const subCategoryId = this.resolveOptionalId(product?.subCategory?.[0]);
        const retailerId = this.resolveOptionalId(zoneRow?.retailer);

        if (categoryId) {
          const matchedCategory = this.prasadamCategoryList.find((item) => item?._id === categoryId);
          if (matchedCategory) {
            this.selectedPrasadamCategory = [matchedCategory];
            this.onPrasadamCategoryChange();
          } else {
            this.pendingPrasadamCategoryId = categoryId;
          }
        }
        if (subCategoryId) {
          this.pendingPrasadamSubCategoryId = subCategoryId;
        }
        if (retailerId) {
          this.pendingRelevantPrasadamRetailerId = retailerId;
          this.loadRelevantPrasadamRetailers(this.model.zone?.[0]?._id);
        }
      },
      error: () => {},
    });
  }

  saveMonthlyPass(valid) {
    if (valid) {
      let body: any = {
      };
      body = { ...this.model };
      body.name = this.toLocalizedString(this.model.name);
      body.description = this.toLocalizedString(this.model.description);
      body.category = this.model.category?.[0]?._id ?? this.model.category?.[0];
      body.relevantService = this.resolveOptionalId(this.model.relevantService) || null;
      body.relevantPrasadam = this.resolveOptionalId(this.model.relevantPrasadam) || null;
      body.products = {};
      body.freePack = {};
      if (!body.category) {
        this.toastr.error('Please select package category', '', { timeOut: 3000, });
        return;
      }
      if (this.monthlyPack.total < this.model.sellingPrice) {
        this.toastr.error('Selling price should be less than total amount', '', { timeOut: 3000, });
        return;
      }

      if (this.model.discount < 0 || this.model.discount > 100) {
        this.toastr.error('Discount need to be 0 to 100', '', { timeOut: 3000, });
        return;
      }

      if (this.model.discorselling == 'disc') {
        body.grossAmount = this.monthlyPack.total;
      } else {
        body.grossAmount = this.monthlyPack.total;
        body.netAmount = this.model.sellingPrice;
      }

      if (this.monthlyPack.list.length == 0) {
        this.noListErrorMsg = 'Please add products';
        return;
      } else {
        this.noListErrorMsg = ''
        for (let i = 0; i < this.monthlyPack.list.length; i++) {
          const element = this.monthlyPack.list[i];
          body.products[element._id] = element.quantity;
        }
        console.log(body);

      }
      if (this.freePack.list.length > 0) {

        for (let i = 0; i < this.freePack.list.length; i++) {
          const element = this.freePack.list[i];
          body.freePack[element._id] = element.quantity;
        }
      }



      body.zone = this.model.zone[0]._id;
      body.status = this.cmnService.getStatusValue(this.model.status);

      console.log(body);

      if (this.monthlyPack.total < this.model.sellingPrice && this.model.discorselling == 'selling') {
        this.toastr.error('Total amount should be greater than selling price', '', {
          timeOut: 3000,
        });
        return;
      }

      if ((this.model.discount < 0 || this.model.discount > 100) && this.model.discorselling == 'disc') {
        this.toastr.error('Discount price need to be between 0 to 100', '', {
          timeOut: 3000,
        });
        return;
      }
      this.showLoader = true;
      if (this.isEditPage) {
        this.apiService.editMonthlyPackAPI(body).subscribe({
          next: (response: any) => {
            if (response.success) {
              this.toastr.success(response.message, '', {
                timeOut: 3000,
              });
              this.router.navigateByUrl('/monthlypass/all');
            } else {
              this.toastr.error(response.message, '', {
                timeOut: 3000,
              });
            }
            this.showLoader = false;
          },
          error: (error) => {
            this.showLoader = false;
            this.toastr.error(error.message, '', {
              timeOut: 3000,
            });
          }
        });
      } else {
        let parameter: any = {
          methodType: "POST",
        }
        delete body._id;
        this.apiService.addMonthlyPackAPI(parameter, body).subscribe({
          next: (response: any) => {
            if (response.success) {
              this.toastr.success(response.message, '', {
                timeOut: 3000,
              });
              this.router.navigateByUrl('/monthlypass/all');
            } else {
              this.toastr.error(response.message, '', {
                timeOut: 3000,
              });
            }
            this.showLoader = false;
          },
          error: (error) => {
            this.showLoader = false;
            this.toastr.error(error.message, '', {
              timeOut: 3000,
            });
          }
        });
      }
    }
  }

  navigateTOList() {
    this.router.navigateByUrl('/monthlypass/all');
  }
}
